import React, { Component } from 'react';
import { connect } from 'react-redux';

import PorCarouselItem from './por-carousel-item';
import PorCarouselGenericItem from './por-carousel-generic-item';
import CarouselRender from './carousel-render';

import './style.css';

class PorCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: []
    };
  }

  renderItems = () => {
    const { porDeals } = this.props;

    this.setState({
      data: [...new Set(porDeals
        .filter(porDeal => porDeal.attributes.brand.name)
        .map(porDeal => porDeal.attributes.brand.id))]
        .map(id => porDeals.find(deal => deal.attributes.brand.id === id))
        .map(porDeal => PorCarouselItem({
          image: porDeal.attributes.image,
          brand: porDeal.attributes.brand
        }))
    }, () => {
      if (porDeals.some(porDeal => porDeal.attributes.product.name)) {
        const { data } = this.state;

        this.setState({ data: [...data, PorCarouselGenericItem()]});
      }
    });
  }

  componentDidUpdate = (prevProps) => {
    const { porDeals } = this.props;

    if (prevProps.porDeals !== porDeals && Array.isArray(porDeals) && !!porDeals.length) {
      this.renderItems();
    }
  }

  componentDidMount = () => {
    this.renderItems();
  }

  render() {
    const { loading } = this.props;
    const { data } = this.state;

    return (
      <CarouselRender loading={loading} data={data} title='POR Deals' />
    );
  }
}

const mapStateToProps = state => ({
  loading: state.latestNews.fetching,
  porDeals: state.porDeals.data
});

export default connect(mapStateToProps)(PorCarousel);



// WEBPACK FOOTER //
// ./src/components/common/home/carousels/por-carousel.jsx